import React, { Component } from 'react';
import Burger from './burger';
import NavItems from './nav-items';

class Nav extends Component {
  render() {
    return (
    <div className="app-nav-container">
        <ul className="app-nav">     
            <NavItems />
        </ul>

        <div className="mobile-nav">
            <Burger />
        </div>
    </div>
    )
  }
}

export default Nav



// WEBPACK FOOTER //
// ./src/shared/nav.js